import Contact from '../components/contact/[slug].js';
export default function contact() {

    return (
        <Contact />
    );
}